import { combineReducers } from 'redux';

import { courses } from './courses';
import { filters } from './filters';
import { courseModal } from './course-modal';
import { categories } from './categories';
import { curriculum } from './curriculum';
import { featuredCourses } from './featured-courses';
import { series } from './series';

export default combineReducers({
    courses,
    series,
    filters,
    courseModal,
    categories,
    curriculum,
    featuredCourses
});
